module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pg-boilerplate",
    attrs: {
      "id": "pgepubid00027"
    }
  }, [_c('h2', {
    staticClass: "calibre11",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('a', {
    attrs: {
      "id": "II"
    }
  }, [_vm._v("II")]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNDER THE WAGON")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("How quietly wound the train, between the low\ndun hills! No lashes cracked, no voices shouted, mule,\nox and horse steadily plodded, and the only sounds\nwere the subdued words of the teamsters encouraging\ntheir animals, and the creaking of the dry wagon-frames.\nBut hark! Right in the midst of this brooding\natmosphere drifted down from the hills upon the\nright a rifle-report; and when Oliver caught sight of\nthe place, here came, full tilt, from flankers’ duty, Dan\nand his comrades; behind them the smoke of the report\nwas still wafting.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Injuns!” This was the alarm. Instantly the\ncaravan was again in a frenzy of commotion. Teamsters\ncurled their lashes and sent their mules into a\nlope, their oxen into a lumbering trot; loud rose a\nmedley of exclamations, orders, rumbling of wheels.\nFrom behind little Oliver, who, his heart in his mouth,\nwas shouting at his lazy cavvy, urging them forward\n(Oh, such a long way must he go!), rode for him the\nrear-guard.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Quick! Roust these critters!” they bade, one to\nanother, and helped him. The cavvy was forced into\na trot.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00028",
      "title": "[31]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_31",
      "title": "[31]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("From right and left and before, the flankers and\nvan-guard were hustling in, bending low and lashing\ntheir horses. Now another report of rifle drifted in;\nanother, and another! Barely pausing in their mad\nflight, Dan and his two comrades were turning in saddle\nand aiming to their rear; jets of white smoke sped\nfrom the muzzles of their guns, as one after another\nthey fired. For there were the Indians—issuing from\nthe crest of the sand-ridge, as if springing out of holes,\nand pouring over, down the slope, trying to catch Dan\nand the other men. They must be Indians, because\nthey flourished lances, and because they were naked,\nwith feathers streaming in the breeze.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("But they couldn’t overtake Dan and his men.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Now from the opposite slope echoed more shots.\nIndians here also! See them come, after that squad\nof scouts! Why didn’t the trappers get out from the\nwagons, and help? Why didn’t the cavvy travel\nfaster? What a lot of Indians! And would the\nwagons be parked, in time, and would there be a hole\nleft for the cavvy? Supposing there wasn’t, and he,\nOliver, must stay outside!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Roust those critters! Roust those critters!”\nurged the men with Oliver, as in the dust and the\nhubbub and the excitement they all shrieked together.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Almost crying, in his earnestness, little Oliver did\nhis best.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("As fast as they arrived at trot and gallop the\nwagons swung to right and to left, tongues inside,"), _c('span', {
    attrs: {
      "id": "pgepubid00029",
      "title": "[32]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_32",
      "title": "[32]"
    }
  })]), _vm._v("\nfront wheels locked with hind wheels of the previously\narrived, the teams were unhitched, the teamsters knelt\nto thrust their yagers between the spokes and aim.\nSmaller and smaller grew the opening, as the oval\nclosed—but amidst yell and murk, in through the\nopening galloped at last the cavvy, and like the rest\nlittle Oliver, breathless, gasping, found himself\n“forted.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("None too soon was it! Down streamed, on either\nflank, the foe—a hideously screaming, whooping,\nfeathered, painted foe: riding, many of them bridleless,\nmost of them garmentless, brandishing tufted lance\nand strung bow, with here and there a gun, face and\nbody daubed lavishly with red and yellow.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Kiowas!” ran through the wagon-fort the muttered\nexclamation. And——")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Get out o’ there, you trappers! You Kit Carson\nmen!” rose the angry cry. “Get out o’ yore holes\nan’ show what you can do!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("But from within the wagons answered never a\nsound nor a stir.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("However, ’twas no time nor place, now, to berate\nthe dastard mountain-men, so false to their reputation.\nThe teamsters were green; the wagon-fort had been\npoorly formed, in the haste; the location was bad,\nfor defense; and darting from wagon to wagon, along\nthe circle, Captain Blunt and other leaders besought\nthe defenders to keep cool and hold their fire.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The painted Kiowas on-rushed as if they were to"), _c('span', {
    attrs: {
      "id": "pgepubid00030",
      "title": "[33]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_33",
      "title": "[33]"
    }
  })]), _vm._v("\nride right over the wagons! “Bang!” spoke the\nyager of a teamster. And “Bang! Bang! Bang!\nBang! Bangity-bang!” bellowed the smooth-bores as\nhis excited mates pulled triggers. In vain Captain\nBlunt and his aides ran, ordered, implored, threatened.\nThe Kiowas were two hundred yards away; too far\nfor a clumsy yager—but at the volley every one fell\nfrom his horse. Were they all killed? Were they?\nHurrah, thought little Oliver. No—a fellow in bright\nyellow leggins was left! But at the “pop!” of little\nOliver’s pistol he, also, fell over! Then——")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("No! More were left, on this side; and on the other\nside! See? Even the yellow-leggins had come to life.\nSaddle-pad after saddle-pad miraculously grew a\nfigure, and on dashed the Kiowas again, as many as\never, with joyous yelps charging empty guns. That\nwas what they had hoped for—empty guns.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Realizing, the panicky teamsters fumbled and made\nmistakes, as rattling their pieces among the wagon-spokes\nthey would pour powder, ram ball, prime pan,\ncock, aim, fire. Disdaining to hang now by thong-loops\nupon the opposite side of their horses, with bows\ndrawn, lances poised, and a gun or two speaking, the\nwild redmen of the sand-hills bore headlong for the\nweakly answering caravan.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("So swiftly they neared! Ere half the yagers had\nbeen reloaded they were within fifty yards. Could\nanything stop them? With thud upon thud their\narrows pelted in and through. Their paint patterns"), _c('span', {
    attrs: {
      "id": "pgepubid00031",
      "title": "[34]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_34",
      "title": "[34]"
    }
  })]), _vm._v("\nwere plain, their faces glared, their guttural exclamations\ncould be heard—and boy Oliver, with one last\nfrantic glance about, dived under a low-hung wagon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Even as he did so, he heard a new sound. It was\nnot “Bang!” and “Bang!” It was “Spat!” “Spat!\nSpat!” and “Whing!” The wagon over him\nswayed, a fresh fume of powder-smoke floated to his\nnostrils. The trappers! He had forgotten the trappers!\nThey had fired, at last, from beneath the wagon-covers—but\nthey were too late.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("It seemed to little Oliver that he waited a long\ntime for the charge. He still heard the whoops and\ngrunts of the Kiowas, right at hand—they were coming,\ncoming, coming! They would scalp the whole\ncaravan, and steal all the cavvy! And while he waited,\nclutching his pistol, another sound arose. Inside the\nwagon-fort was a new commotion—a clamor of voices,\na shuffling of hasty feet, a rattle of stirrup and a thud\nof many hoofs!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Had the Kiowas broken through? They must!\nThe wagon over him swayed again, something struck\nit, almost shoved it to one side; he peered, craning\nhis neck to see into the dust—and a set of hoofs passed\nright over his head. He glimpsed a buckskin rider,\non the "), _c('em', {
    staticClass: "calibre9"
  }, [_vm._v("outside")]), _vm._v("; a trapper had forced his horse between\nthe loosely locked wheels of the two wagons, and was\non the "), _c('em', {
    staticClass: "calibre9"
  }, [_vm._v("outside")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The Kiowas were here, too. Many were upon the\nground, and the red which stained them was redder"), _c('span', {
    attrs: {
      "id": "pgepubid00032",
      "title": "[35]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_35",
      "title": "[35]"
    }
  })]), _vm._v("\nthan the red of vermilion paint. Yes, many and\nmany were upon the ground. But the others were\ncharging about; little Oliver had not been waiting long,\nafter all. He knelt, trembling in his eagerness. There\nwere still a host of Kiowas, and they were very angry.\nThe wagon-fort must be fairly oozing trappers,\nmounted; for from either direction they were galloping\ninto the field, their lines loose, their buckskin-clad,\nfringed bodies leaning forward, pistol in hand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Across the little space, to the line of prone and\ndoubled figures they raced. “Bang! Bang!” jetted\ntheir pistols. The live Kiowas, dodging and hanging\nto the necks of their ponies, parted before the counter-charge,\nswerved at the volley, let the trappers into their\nmidst—and with a great savage yell of vengeance\nturned, to close. For the trappers’ pistols were empty,\nas the teamsters’ yagers had been! Now long scores\nwould be settled; a trapper’s scalp was worthy many a\ndance.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("But what a surprise! With “Bang! Bang!” the\npistols spoke again and yet again and again, and needed\nno reloading! Down from their ponies plunged stricken\nKiowas, fierce career ended; around wheeled the unstricken,\nlying low upon pony backs, hammering pony\nsides with desperate heels, fleeing the wondrous medicine\nof the whites. And through the lodges of plains\nand desert spread the wail: “White man shoot one\ntime with rifle and six time with butcher-knife!” Thus\nbefore the eyes of boy Oliver, under the wagon, was"), _c('span', {
    attrs: {
      "id": "pgepubid00033",
      "title": "[36]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_36",
      "title": "[36]"
    }
  })]), _vm._v("\nbroken by Kit Carson and his men the power of the\ncaravan pirates.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Cheering and lashing, the trappers made pursuit\nclear out of sight. All around the wagon-fort the\nbattle had resulted the same. With that result the\nteamsters really had little to do, after their first ineffective\nvolley; and they could only stare, open-mouthed,\nwhen so unexpectedly the trapper rifles emptied the\nsaddle-pads in earnest, and without hesitation out the\ntrappers charged. They still were staring, scarcely\ncrediting, when back the trappers rode, in little squads,\ngrim and weary, but not without their banter. Slipped\nunder the belts they brought scalps. Oliver saw Sol\nSilver, and he recognized others—and he found Kit\nCarson.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Kit Carson chanced to ride close in, past Oliver’s\nwagon, and paused here to shake hands with Captain\nBlunt. His face was flushed and his lips tight together;\nand his eyes! They were terrible eyes, not\nnow steel-gray but a vivid blue, flaming like living\namethysts or like blue stars.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Yes, sir,” he said, in reply to Captain Blunt’s\ncongratulations. “"), _c('a', {
    attrs: {
      "href": "#/Text/Section0002#i_frontis"
    }
  }, [_vm._v("We taught those thar red demons\na lesson they’ll not forget.")]), _vm._v(" It’s all over. Go ahead\nwith yore caravan.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Hearing, Oliver shame-facedly crawled out from\nbeneath the wagon; and it seemed to him that Kit\nCarson the Great saw him, and smiled friendly at him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Some of the teamsters would have liked to mingle"), _c('span', {
    attrs: {
      "id": "pgepubid00034",
      "title": "[37]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_37",
      "title": "[37]"
    }
  })]), _vm._v("\nwith the trappers and to rehearse what had been done,\nand what had not been done, and what might have\nbeen done, in the short fight; but “Catch up! Ketch\nup!” and “Fall in, men!” rang the sharp orders of\nthe caravan officers. Time had been lost, water was\ndwindling, every moment was precious; the march\nmust proceed at once.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("So team after team settled to collar and yoke,\nwagon after wagon lurched forward; and presently\nlittle Oliver was once more in the rear of all, driving\nhis cavvy through the drifting dust. Strangely\nenough, not a man of caravan or trappers had been\nwounded, and only one mule had received an arrow,\nin the hip.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Wall, boy, how’d you like the Kiowas?” It was\nSol Silver, again, back beside Oliver. Brown-bearded\nand burly, he looked the same as ever and as if he had\nnot been in any fight. But tucked in his belt were two\nscalps. “Whar’s yore pelts for trophies?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“I haven’t any. I wasn’t close enough,” answered\nOliver, truthfully.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Didn’t I see you chasing the chief on yore mule?”\ninvited Sol. “Kit took one chief an’ you took t’other.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Oliver flushed, and shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“No, I didn’t. I didn’t try.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Whar war ye, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Oliver flushed more and hung his head.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Under a wagon.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00035",
      "title": "[38]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_38",
      "title": "[38]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Haw! Haw!” roared Sol, and chuckled through\nhis beard. “What war the matter?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Oliver wanted to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“I guess I was afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Haw! Haw!” roared Sol. “Guess mebbe you\nwar.” Then he sobered. “You fetched yore cavvy\nin, though, I hear tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Men helped me.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“But you come in behind an’ not ahead, jest the\nsame,” asserted Sol. “That war right. Warn’t ye\nafraid the Injuns’d get ye, ’fore you war forted?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Oliver nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“That’s right, that’s right,” said Sol. “You corralled\nyore cavvy fust, an’ then you crawled under\nthe wagon. Don’t blame ye for being afraid. Only\na fool’s never afraid. Being afraid doesn’t make anybody\na coward. I ’spec’ you thought us trappers war\nafraid, too, when we crawled into the wagons, ’fore\nyou crawled under one.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Oliver must nod again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“We warn’t; not this time. But I reckon we’ve\nall been afraid, many another time. This time we\ncrawled into the wagons so the Injuns wouldn’t see\nus. If the Injuns spied Kit Carson men riding with a\nwagon-train they’d never attack, you bet. These\nSouthwest Injuns know us Kit Carson men by sight,\nnow. An’ you jest say ‘Kit Carson’ to ’em, an’ out\ncomes the peace-pipe mighty quick. They can depend\non Kit to fight ’em if they’re bound to fight, or to talk"), _c('span', {
    attrs: {
      "id": "pgepubid00036",
      "title": "[39]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_39",
      "title": "[39]"
    }
  })]), _vm._v("\nstraight with ’em if they want to talk straight. He\nair a bad enemy, an’ he air a best friend. He shoots\nplumb centre, with both tongue an’ rifle.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("The noon camp was very brief; long enough only\nfor the animals to breathe, and for the men to munch\na strip each of dried meat, while coffee boiled. But it\nwas long enough for Oliver to sidle near where Kit\nCarson appeared to be telling stories to a group of\ncaravan men. Anybody should know that Kit Carson\nmust have marvellous stories to tell.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“But what about that time you sneaked on hands\nan’ knees, through the snow, close to the Injun fort,\nnear head o’ the Arkansas, an’ cut the hosses loose an’\ndrove ’em off with snow-balls?” asked Teamster\nHenry.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“When war that?” inquired Kit Carson, as if\nmildly surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Some years back. When you fust went into the\nmountains.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Oh,” said Kit Carson, slowly rubbing his chin.\n“That war some o’ Captain Gant’s men. Captain\nGant had lost some hosses, by these Crows, an’ his\nmen went an’ got ’em. Can’t do without hosses, in the\nmountains.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“But weren’t you along?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Wall, I might have followed,” drawled Carson,\nuneasily. “I don’t exactly remember ’bout that. They\nwar brave fellows, though. They——”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00037",
      "title": "[40]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_40",
      "title": "[40]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Reckon you’ve made a heap o’ Injuns run, all\nthe same,” interrupted an admiring caravaner.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Sartinly, sartinly,” agreed Kit Carson. “Part\nthe time I’ve been running after them, an’ most the\ntime they’ve been running after "), _c('em', {
    staticClass: "calibre9"
  }, [_vm._v("me")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“You gave ’em a good dose this time, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Wall, we had to; we had to. My men had to,”\ndeclared Kit Carson, and he brought down his clenched\nhand. “But we didn’t like to; that is, we oughtn’t\nto like to. Nobody likes to kill human beings; an’\nthese Injuns, pore critters, ain’t been raised to know\nany better’n to rob an’ murder. They think this hyar’s\ntheir country, an’ we whites air using up the game they\ndepend on. But o’ course, these Kiowas come down\n’specting to wipe out a defenceless train that warn’t\ndoing ’em any harm, an’ we simply "), _c('em', {
    staticClass: "calibre9"
  }, [_vm._v("had")]), _vm._v(" to shoot into\n’em. If this caravan didn’t lick ’em, proper, some\nother caravan must. Now the job’s over.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“How many did you kill, of ’em? You got the\nchief, didn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Me?” queried Kit Carson, again mildly surprised.\n“Oh, thar war jest a lot o’ shooting an’ riding\naround, an’ we did the best we could. We war lucky\nto have these six-shooter pistols—revolvers, they call\n’em. Ever see ’em before?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“You’ll never get him to talk about himself,”\nwarned a trapper to a listener near Oliver. “Sometimes\nhe will, with Injuns, ’cause they understand\nboasting, an’ they all know Kit Carson. But ’tain’t"), _c('span', {
    attrs: {
      "id": "pgepubid00038",
      "title": "[41]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_41",
      "title": "[41]"
    }
  })]), _vm._v("\nwhite man way with him. So you might as well quit.\nHe hates the leetle letter ‘I.’”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“That’s heap weepon, shorely,” commented a teamster,\nexamining. “Beats the big gun of that boy,\nyonder.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Now, this caused everybody to look at Oliver,\nwhich was most embarrassing. He was well aware\nthat his little pistol was not so grand as these new-style\nrevolvers; and he did not like to be laughed at.\nBut Kit Carson, as if glad to change the subject from\nhimself, smiled and said quickly:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Hello, boy. You’re safe, they say, an’ so’s yore\ncavvy. You’ll make a warrior yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Oliver must hang his head and turn and twist.\nHe didn’t deserve such praise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Yes, sir; but I crawled under a wagon,” he\nblurted. “I didn’t fight any.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Haw! Haw!” rose the laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Wall,” remarked Kit Carson, quietly, but clearly,\n“I’ve seen many a time when I wished I war under a\nwagon, myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("At this moment “Catch up! Ketch up!” sounded\nthe calls, and the talk must end, while the caravan\nresumed the trail.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Not another Indian came into sight, as the train\nplodded on, with the Kit Carson men still acting as\nescort. At sunset camp was made for the night, beside\na dried water-course where grew a few hardy\ncottonwoods. Sitting wearily his old mule, watching"), _c('span', {
    attrs: {
      "id": "pgepubid00039",
      "title": "[42]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_42",
      "title": "[42]"
    }
  })]), _vm._v("\nhis cavvy until the night guard should relieve him,\nlittle Oliver wished that he was by one of the trappers’\nmess-fires instead, where Kit Carson might smile upon\nhim, again. However, while he sat upon the mule,\na figure rode to him, through the dusk. It was the\nbooming Sol Silver, once more. Sol spoke direct.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Boy, Kit sent me to ask how’d you like to go on\nto Touse with us, ’stead o’ to Santy Fee with the\ncaravan?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Oliver gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Can I? With you!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“If you want to, an’ if Kit decides so. We take\nthe Touse trail in the morning. Now, if you’re to\ncome, thar’ll be a fire made at the foot o’ that thar cottonwood,\nstanding out alone. See it? Wall, if you\nsee the flare, pretty soon, you’ll know. But you’ll lose\nyore wages from the caravan. They’ll not pay ye\nless you go through to Santy Fee with ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“I don’t care,” stammered Oliver. “I’d rather go\nto Touse, with you. Can I be a Kit Carson man?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("“Reckon you can, some time, if you got it in you;\nan’ if Kit thinks you have, you have. All right; don’t\nsay anything, an’ watch for the fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_vm._v("Sol rode back to his mates. Oliver watched\nanxiously. Hurrah, the fire flared, just as he was\ntrudging to supper. And when, in the morning, caravan\nand trappers parted company, into the west on the\nTaos trail rode with the Kit Carson men little Oliver\nWiggins.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00040",
      "title": "[43]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_43",
      "title": "[43]"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a58ec006","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0008.vue
// module id = 78
// module chunks = 0